import { render, staticRenderFns } from "./CategoryGrid.vue?vue&type=template&id=6ff9fbca&"
import script from "./CategoryGrid.vue?vue&type=script&lang=js&"
export * from "./CategoryGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports